export default "__VITE_ASSET__ae1c8fdf__"